const CARD_ITEMS = [
  {
    title: '动作大片',
    desc: '震撼视觉特效，肾上腺素飙升的极致体验',
    img: 'https://readdy.ai/api/search-image?query=explosive%20action%20movie%20scene%20with%20car%20chase%20in%20a%20modern%20city%2C%20fiery%20explosions%2C%20dynamic%20camera%20angles%2C%20cinematic%20lighting%20with%20warm%20orange%20highlights%2C%20intense%20atmosphere%2C%20dark%20moody%20background%2C%20no%20text%20or%20logos&width=800&height=500&seq=card-action-01&orientation=landscape',
    tag: '热播',
    icon: 'ri-sword-line',
  },
  {
    title: '喜剧佳作',
    desc: '欢乐时光不打烊，高分喜剧笑料不断',
    img: 'https://readdy.ai/api/search-image?query=bright%20warm%20comedic%20scene%20with%20cheerful%20atmosphere%2C%20soft%20golden%20lighting%2C%20cozy%20living%20room%20setting%20with%20warm%20toned%20decor%2C%20feel%20good%20vibes%2C%20cinematic%20depth%20of%20field%2C%20rich%20amber%20tones%2C%20no%20text%20or%20logos&width=800&height=500&seq=card-comedy-02&orientation=landscape',
    tag: '热门',
    icon: 'ri-emotion-happy-line',
  },
  {
    title: '科幻巨制',
    desc: '未来世界想象无界，顶级科幻盛宴',
    img: 'https://readdy.ai/api/search-image?query=futuristic%20sci%20fi%20landscape%20with%20towering%20neon%20lit%20megastructures%2C%20flying%20vehicles%2C%20deep%20space%20background%2C%20cyan%20and%20amber%20lighting%20contrast%2C%20epic%20scale%2C%20atmospheric%20haze%2C%20cinematic%20composition%2C%20dark%20moody%20tone%2C%20no%20text%20or%20logos&width=800&height=500&seq=card-scifi-03&orientation=landscape',
    tag: '精选',
    icon: 'ri-rocket-line',
  },
  {
    title: '爱情经典',
    desc: '心动瞬间永恒定格，温情故事触动人心',
    img: 'https://readdy.ai/api/search-image?query=romantic%20sunset%20scene%20with%20warm%20golden%20light%2C%20soft%20focus%20cinematic%20look%2C%20elegant%20couple%20silhouettes%20against%20glowing%20sky%2C%20dreamy%20atmosphere%2C%20film%20grain%20texture%2C%20vintage%20warm%20tones%2C%20no%20text%20or%20logos&width=800&height=500&seq=card-romance-04&orientation=landscape',
    tag: '推荐',
    icon: 'ri-heart-line',
  },
  {
    title: '悬疑烧脑',
    desc: '层层反转智商对决，悬疑迷的终极挑战',
    img: 'https://readdy.ai/api/search-image?query=mysterious%20noir%20scene%20with%20dramatic%20shadows%20and%20a%20single%20shaft%20of%20light%2C%20rain%20soaked%20alleyway%2C%20film%20noir%20aesthetic%2C%20high%20contrast%20black%20and%20white%20with%20subtle%20warm%20tones%2C%20atmospheric%20fog%2C%20cinematic%20composition%2C%20no%20text%20or%20logos&width=800&height=500&seq=card-suspense-05&orientation=landscape',
    tag: '高分',
    icon: 'ri-search-eye-line',
  },
  {
    title: '动画精选',
    desc: '全年龄段的奇妙冒险，精美动画盛宴',
    img: 'https://readdy.ai/api/search-image?query=beautiful%20animated%20fantasy%20landscape%20with%20vibrant%20colors%2C%20magical%20floating%20islands%2C%20soft%20glowing%20particles%2C%20whimsical%20forest%20setting%2C%20warm%20golden%20sunlight%20filtering%20through%20trees%2C%20dreamy%20atmosphere%2C%20cinematic%20depth%2C%20no%20text%20or%20logos&width=800&height=500&seq=card-animation-06&orientation=landscape',
    tag: '新片',
    icon: 'ri-movie-line',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100 mb-3">
            精选分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大类型应有尽有，总有一款适合你的口味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop="">
          {CARD_ITEMS.map((item) => (
            <a
              key={item.title}
              href="#ranking"
              className="group block bg-background-200/50 rounded-lg overflow-hidden border border-background-300/30 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-300/30">
                <img
                  src={item.img}
                  alt={`五姑娘影院${item.title}`}
                  title={`五姑娘影院${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-200/80 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500/80 text-foreground-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-6 h-6 flex items-center justify-center text-primary-500">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </h3>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}